var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Github"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10990_10719",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.12207,
    y: 0.465088,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10990_10719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Github_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12207 2.46509C4.80715 2.46509 2.12207 5.21772 2.12207 8.61603C2.12207 11.3347 3.84214 13.638 6.2252 14.4536C6.52354 14.5102 6.63404 14.3214 6.63404 14.1553C6.63404 14.008 6.63036 13.6229 6.62667 13.1093C4.95817 13.4794 4.60457 12.2862 4.60457 12.2862C4.33201 11.5763 3.93791 11.3875 3.93791 11.3875C3.39279 11.0062 3.97842 11.0137 3.97842 11.0137C4.57879 11.059 4.89923 11.6481 4.89923 11.6481C5.4333 12.5883 6.30255 12.3164 6.64509 12.1578C6.70034 11.7613 6.85504 11.4895 7.02446 11.3347C5.69113 11.1799 4.2915 10.6512 4.2915 8.29507C4.2915 7.62296 4.52354 7.07546 4.91028 6.64501C4.84767 6.49019 4.64141 5.8634 4.96922 5.0176C4.96922 5.0176 5.47382 4.85146 6.61931 5.64817C7.09813 5.51224 7.6101 5.44427 8.12207 5.4405C8.63036 5.4405 9.14601 5.51224 9.62483 5.64817C10.7703 4.85146 11.2749 5.0176 11.2749 5.0176C11.6027 5.8634 11.3965 6.49019 11.3339 6.64501C11.7169 7.07546 11.949 7.62296 11.949 8.29507C11.949 10.6588 10.5456 11.1761 9.20863 11.3309C9.42225 11.5197 9.61747 11.8973 9.61747 12.4712C9.61747 13.2944 9.6101 13.9551 9.6101 14.159C9.6101 14.3252 9.71691 14.514 10.0226 14.4536C12.4057 13.638 14.1221 11.3347 14.1221 8.6198C14.1221 5.21772 11.437 2.46509 8.12207 2.46509Z",
    fill: "#5F6368"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/githubIcon.4323f234d2a2e44ed8e969a9ff578c31.svg";
export { ForwardRef as ReactComponent };